(() => {
  function init(root = document) {
    root.querySelectorAll('[data-flavors]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const buttons = [...section.querySelectorAll('[data-flavor-button]')];
      const panels = [...section.querySelectorAll('[data-flavor-panel]')];
      const activate = index => {
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        panels.forEach((panel, i) => { panel.hidden = i !== index; panel.classList.remove('reveal-in'); if (i === index) panel.classList.add('reveal-in'); });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus(); activate(next);
        });
      });
      activate(0);
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const variants = section.querySelector('[data-variant-select]'), plans = section.querySelector('[data-selling-plan]');
      const allocations = JSON.parse(section.querySelector('[data-plan-allocations]')?.textContent || '{}');
      const refresh = () => {
        const variant = variants.selectedOptions[0];
        let price = variant.dataset.price;
        let validPlan = true;
        if (plans) {
          const availablePlans = allocations[variant.value] || [];
          [...plans.options].forEach(option => { option.disabled = !!option.value && !availablePlans.some(p => p.id === option.value); });
          if (plans.selectedOptions[0]?.disabled) { const next = [...plans.options].find(o => !o.disabled); if (next) plans.value = next.value; }
          validPlan = !!plans.selectedOptions[0] && !plans.selectedOptions[0].disabled;
          const allocation = availablePlans.find(p => p.id === plans.value); if (allocation) price = allocation.price;
        }
        section.querySelector('[data-product-price]').textContent = price;
        const button = section.querySelector('[data-add-button]');
        button.disabled = variant.dataset.available !== 'true' || !validPlan;
        button.textContent = variant.dataset.available !== 'true' ? 'Sold out' : !validPlan ? 'Unavailable' : 'Add to bag';
      };
      const requested = new URLSearchParams(window.location.search);
      if (variants && [...variants.options].some(o => o.value === requested.get('variant'))) variants.value = requested.get('variant');
      if (plans && [...plans.options].some(o => o.value === requested.get('selling_plan'))) plans.value = requested.get('selling_plan');
      variants?.addEventListener('change', refresh); plans?.addEventListener('change', refresh); refresh();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-flavor-panel]');
    if (panel) panel.closest('[data-flavors]').querySelector(`[data-flavor-button="${panel.dataset.flavorPanel}"]`)?.click();
  });
  document.addEventListener('click', event => { const link = event.target.closest('.mobile-menu a'); if (link) link.closest('details').removeAttribute('open'); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => {menu.open=false; menu.querySelector('summary').focus();}); });
})();

// One isolated controller per hero. No scroll interception or permanent animation loop.
(() => {
  const controllers = new Map();
  const clamp = value => Math.max(0, Math.min(1, value));
  function mount(hero) {
    if (controllers.has(hero) || hero.dataset.heroMotion !== 'true') return;
    const track = hero.querySelector('.hero-track');
    const stage = hero.querySelector('.hero-main');
    if (!track || !stage) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 900px)');
    let frame = 0, current = null, target = 0, brandProgress = 0, start = 0, distance = 1;
    let animations = [], destroyed = false;
    const set = (name, value) => hero.style.setProperty('--' + name, value);
    function draw(p) {
      const mobile = !desktop.matches;
      set('cup-x', `${p * (mobile ? 8 : -12)}px`);
      set('cup-y', `${p * (mobile ? 38 : -34)}px`);
      set('cup-rotate', `${-10 + p * (mobile ? 16 : 27)}deg`);
      set('cup-scale', 1 + Math.sin(p * Math.PI) * (mobile ? .035 : .13));
      set('orbit-y', `${p * (mobile ? -22 : 42)}px`);
      set('orbit-scale', 1 + p * (mobile ? .08 : .2));
      set('badge-x', `${p * (mobile ? -5 : -18)}px`);
      set('badge-y', `${p * (mobile ? -22 : -85)}px`);
      set('badge-rotate', `${-10 - p * 22}deg`);
      set('copy-y', `${p * (mobile ? -12 : -52)}px`);
      set('caption-y', `${p * (mobile ? -8 : 28)}px`);
      set('brand-y', `${brandProgress * (mobile ? -22 : -65)}px`);
      set('brand-opacity', 1 - brandProgress * .65);
    }
    function tick() {
      frame = 0;
      if (destroyed || reduced.matches) return;
      current = current === null ? target : current + (target - current) * .16;
      if (Math.abs(current - target) < .0005) current = target;
      draw(current);
      if (current !== target) frame = requestAnimationFrame(tick);
    }
    function scroll() {
      if (reduced.matches) return;
      target = clamp((window.scrollY - start) / distance);
      const rect = hero.getBoundingClientRect();
      brandProgress = clamp(-rect.top / Math.max(1, hero.querySelector('.hero-brand').offsetHeight));
      if (!frame) frame = requestAnimationFrame(tick);
    }
    function measure() {
      if (destroyed) return;
      track.style.height = desktop.matches && !reduced.matches ? `${stage.offsetHeight + innerHeight * .85}px` : '';
      const top = parseFloat(getComputedStyle(stage).top) || 76;
      start = track.getBoundingClientRect().top + window.scrollY - (desktop.matches ? top : innerHeight * .25);
      distance = desktop.matches ? Math.max(1, track.offsetHeight - stage.offsetHeight) : Math.max(1, stage.offsetHeight * .8);
      scroll();
    }
    function intro() {
      if (reduced.matches || hero.getBoundingClientRect().top < -150) return;
      const cup = hero.querySelector('.hero-product .cup-window');
      if (cup) animations.push(cup.animate([
        { transform:'translate3d(0,80px,0) rotate(-13deg) scale(.86)', opacity:0 },
        { transform:'translate3d(0,0,0) rotate(0deg) scale(1)', opacity:1 }
      ], {duration:1400, easing:'cubic-bezier(.16,1,.3,1)', fill:'backwards'}));
      [hero.querySelector('.hero-brand img'), ...hero.querySelectorAll('.hero-copy > *'), hero.querySelector('.round-note')].filter(Boolean).forEach((el,i) => {
        // Individual translate preserves the badge's independent scroll rotation.
        animations.push(el.animate([{opacity:0,translate:'0 28px'},{opacity:1,translate:'0 0'}],{duration:1000,delay:i*85,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'}));
      });
    }
    function preference() {
      cancelAnimationFrame(frame); frame = 0; current = null;
      animations.forEach(a => a.cancel()); animations = [];
      hero.classList.toggle('hero-motion-on', !reduced.matches);
      if (reduced.matches) track.style.height = '';
      if (!reduced.matches) { measure(); intro(); }
    }
    const resize = new ResizeObserver(measure);
    resize.observe(track); resize.observe(stage); resize.observe(hero.querySelector('.hero-brand'));
    window.addEventListener('scroll', scroll, {passive:true});
    window.addEventListener('resize', measure, {passive:true});
    reduced.addEventListener('change', preference); desktop.addEventListener('change', measure);
    preference();
    document.fonts.ready.then(() => { if (!destroyed) measure(); });
    controllers.set(hero, () => {
      destroyed = true; cancelAnimationFrame(frame); resize.disconnect(); animations.forEach(a=>a.cancel());
      window.removeEventListener('scroll', scroll); window.removeEventListener('resize', measure);
      reduced.removeEventListener('change', preference); desktop.removeEventListener('change', measure);
      hero.classList.remove('hero-motion-on'); controllers.delete(hero);
    });
  }
  const mountAll = root => root.querySelectorAll('[data-hero-motion]').forEach(mount);
  mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [hero, cleanup] of controllers) if (event.target.contains(hero)) cleanup();
  });
})();

/* v23.68: autoplay videos only load when they come near the viewport, and pause when they leave.
   The three cook-along / packing clips are 5–10 MB each in Shopify Files; autoplay used to fetch
   all of them on page load. Markup: <video data-lazy-video="src" poster=... muted loop playsinline preload="none"> */
(() => {
  const vids = [...document.querySelectorAll('video[data-lazy-video]')];
  if (!vids.length) return;
  const play = v => { v.play && v.play().catch(() => {}); };
  const load = v => { if (!v.src) { v.src = v.getAttribute('data-lazy-video'); v.preload = 'auto'; v.load(); } };
  if (!('IntersectionObserver' in window)) { vids.forEach(v => { load(v); play(v); }); return; }
  const io = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) { load(v); play(v); } else if (v.src) v.pause();
  }), { rootMargin: '60% 0px' });
  vids.forEach(v => io.observe(v));
})();
